import Joi from 'joi'
import {emailValidation, inputStringValidation} from 'validation'

export const createTicketSchema = Joi.object({
  assignee: Joi.number().empty('unassign').default(null).messages({'number.base': 'Assignee must be specified'}),
  mailbox: Joi.number().required().messages({'number.base': 'Mailbox must be specified'}),
  subject: Joi.string().trim().min(2).required(),
  email: emailValidation.required(),
  name: inputStringValidation.required(),
})
